module.exports = __webpack_public_path__ + "img/tabla.7e2e7180.svg";